export const LoadingConstants = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
} as const;

export type LoadingConstants = keyof typeof LoadingConstants;
